import React, { useContext, useEffect, useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { usePageLocalization } from "@sbi-international/boutik.gatsby.plugin.multilocale";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { ServicesContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/servicesContext";
import { MagentoCustomerContext } from "@sbi-international/boutik.gatsby.plugin.services/dist/src/contexts/magentoCustomerContext";
import { FeedbackContext } from "../../contexts/feedback/feedbackContext";
import { IProduct } from "@sbi-international/boutik.gatsby.plugin.services";

import  { pushAddToCartEvent }  from "../../../src/utils/useGTM_UA";
import { Icon } from "../../components/primitives";
import { PartsFilteredPart } from "../../models/partsFilteredPart";


type PartPreviewProps = {
    coord: any;
    allParts: PartsFilteredPart[];
};

export function PartPreview(props: PartPreviewProps) {
    const [isVisible, setIsVisible] = useState(false);
    const { coord, allParts } = props;
    const { currentLocale } = usePageLocalization();

    const servicesContext = useContext(ServicesContext);
    const magentoCustomerContext = useContext(MagentoCustomerContext);
    
    const cartService = servicesContext?.magento.cartService;

    const svgCart =
        "M9.384,19.186a1.7,1.7,0,1,1-1.7-1.7,1.7,1.7,0,0,1,1.7,1.7Zm11.355,0a1.7,1.7,0,1,1-1.7-1.7A1.7,1.7,0,0,1,20.739,19.186Zm0-7.381V4.992H7.113A1.136,1.136,0,0,0,5.977,3.856H2.571V4.992H4.842L5.695,12.3a2.271,2.271,0,0,0,1.418,4.044H20.739V15.211H7.113a1.136,1.136,0,0,1-1.136-1.136s0-.008,0-.012L20.739,11.8Z";
    const code = coord?.note?.split("//")?.[1].replace(":", "");

    const part = allParts.find((part: any) => part?.part?.code === code);

    const { addAlert } = useContext(FeedbackContext);

    return (
        <div
            className="coord-test"
            style={{
                left: coord.x,
                top: coord.y,
            }}
            onClick={() => setIsVisible(!isVisible)}
        >
            {isVisible && (
                <div className="preview" onClick={(event) => event.stopPropagation()}>
                    <FontAwesomeIcon
                        icon={faTimes}
                        className="close"
                        onClick={() => setIsVisible(false)}
                    />
                    <div className="part-number">
                        <span>{part?.part?.attributes?.schema_number?.values[0][currentLocale]}</span>
                    </div>
                    <div className="title">
                        <span>{part?.part?.title[currentLocale]}</span>
                    </div>
                    <span className="code">{part?.part?.code}</span>
                    <div className="price">
                        <span>
                            {part?.currentPrice?.regularPrice?.value === 0  
                                ? "--"
                                : part?.currentPrice?.regularPrice?.formattedValue}
                        </span>
                    </div>
                    <div className="addToCart">
                        <div
                            className="buy-icon"
                            onClick={(event) => {
                                event.stopPropagation();
                               // setQuickCartVisible(true);
                                cartService.operations
                                    .addProductToCart({ sku: code, quantity: 1 }, magentoCustomerContext)
                                    .then((res: any) => {
                                        // console.log(res);
                                        // GTM GA4
                                        pushAddToCartEvent({
                                            id: code,
                                            price: part?.currentPrice?.finalPrice?.value ?? undefined,
                                            currency: part?.currentPrice?.finalPrice?.currency,
                                            qty: 1,
                                        });
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                        addAlert({
                                            message: error,
                                            status: "error",
                                        });
                                    });
                            }}
                        >
                            <span>
                                <span>+</span>
                                <Icon
                                    d={svgCart}
                                    size="20"
                                    viewBox="0 0 18.169 17.033"
                                    transform="translate(-2.571 -3.856)"
                                />
                            </span>
                        </div>
                    </div>

                    <div className="arrow-down" />
                </div>
            )}
        </div>
    );
}
